import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class QuotasSummaryModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    isGeneralAdmissionArea() {
        return this.object.general_admission_area !== undefined;
    }

    get generalAdmissionArea() {
        return this.object.general_admission_area;
    }

    get id() {
        return this.object.contingent ? this.object.contingent : this.object.general_admission_area;
    }

    static listUrl({ organizationId, eventId, inventoryId }) {
        if (!organizationId || !eventId || !inventoryId) {
            throw new ArgumentError(`[Model][QuotasSummary][getAll] organizationId, eventId and inventoryId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/inventories/${inventoryId}/quotas/summary`;
    }
}
